import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainApp from "./mainMenu";
import AppShell from "./AppShell";
import { screens } from "./utils/links";
import TapThat from "./tapThat";
import TapThatSimpleGame from "./tapThat/simpleGame";
import TapThatHighScore from "./tapThat/highScore";
import TapThatInstructions from "./tapThat/instructions";
import PrecisionClicker from "./precisionClicker";
import PrecisionClickerPlay from "./precisionClicker/play";
import PrecisionClickerHowTo from "./precisionClicker/howTo";
import PrecisionClickerHighScore from "./precisionClicker/highScore";
import { AwsRum, AwsRumConfig } from "aws-rum-web";

let awsRum: AwsRum | undefined;
const RUM_APP_ID = process.env.REACT_APP_RUM_APPLICATION_ID;
const RUM_ROLE_ARN = process.env.REACT_APP_RUM_GUEST_ROLE_ARN;
const RUM_IDENTITY_POOL = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;
const RUM_REGION = process.env.REACT_APP_RUM_REGION;

if (RUM_APP_ID && RUM_ROLE_ARN && RUM_IDENTITY_POOL && RUM_REGION) {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      guestRoleArn: RUM_ROLE_ARN,
      identityPoolId: RUM_IDENTITY_POOL,
      endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: false,
    };

    awsRum = new AwsRum(RUM_APP_ID, "1.0.0", RUM_REGION, config);
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}

const router = createBrowserRouter([
  {
    path: screens.main,
    element: <MainApp />,
  },
  {
    path: screens.tapThat.main,
    element: <TapThat />,
  },
  {
    path: screens.tapThat.simpleGame,
    element: <TapThatSimpleGame />,
  },
  {
    path: screens.tapThat.instructions,
    element: <TapThatInstructions />,
  },
  {
    path: screens.tapThat.highScore,
    element: <TapThatHighScore />,
  },
  {
    path: screens.precisionClicker.main,
    element: <PrecisionClicker />,
  },
  {
    path: screens.precisionClicker.play,
    element: <PrecisionClickerPlay />,
  },
  {
    path: screens.precisionClicker.howTo,
    element: <PrecisionClickerHowTo />,
  },
  {
    path: screens.precisionClicker.highScore,
    element: <PrecisionClickerHighScore />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppShell>
      <RouterProvider router={router} />
    </AppShell>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
